import type {
  FieldLayoutCondition,
  FieldLayoutConditionValue,
} from "@repo/types";

// compute that a condition is met for dynamic form field logic
export const evaluateCondition = (
  cond: FieldLayoutCondition | FieldLayoutConditionValue,
  values: { [x: string]: unknown }
): unknown => {
  switch (cond.type) {
    case "constant":
      // return constant value
      return cond.value;

    case "field":
      // return value from a field
      return values[cond.field];

    case "condition": {
      // compute an operation (e.g., comparison, a and b, etc.)
      const compute = (index: number): unknown =>
        evaluateCondition(cond.operands[index], values);

      switch (cond.operator) {
        case "!":
          return !compute(0);
        case "==":
          return compute(0) === compute(1);
        case "!=":
          return compute(0) !== compute(1);
        case "&&":
          return cond.operands.every((_, ind) => !!compute(ind));
        case "||":
          return cond.operands.some((_, ind) => !!compute(ind));
        case ">":
          return (compute(0) as number) > (compute(1) as number);
        case "<":
          return (compute(0) as number) < (compute(1) as number);
        case ">=":
          return (compute(0) as number) >= (compute(1) as number);
        case "<=":
          return (compute(0) as number) <= (compute(1) as number);
      }
      return compute(0); // sanity
    }
  }
  return true; // sanity
};
